import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "./core/authentication/auth.service";
import { SwUpdate } from "@angular/service-worker";
import { NavStateService } from "./shell/nav-state.service";
import { Alert } from "selenium-webdriver";
import { Router } from "@angular/router";

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  private hardReload: boolean = false;
  private checkVersionFromLogin: boolean = false;

  constructor(
    public toasterService: ToastrService,
    private authService: AuthService,
    public swUpdate: SwUpdate,
    private navStateService: NavStateService,
    private router: Router
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    sessionStorage.setItem("customer-version", "1");

    req = this.addHeaderCustomerVersion(req);
    this.checkVersionFromLogin = req.headers.has("check-version-from-login");

    return next.handle(req).pipe(
      tap((evt) => { }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          try {
            switch (err.status) {
              case 400:
                console.log(err.error);

                if (err.error?.errors?.Name?.length) {
                  this.toasterService.error(err.error.errors.Name[0], "Error", {
                    positionClass: "toast-bottom-right",
                    progressAnimation: "decreasing",
                    progressBar: true,
                  });
                } else if (err.error?.errors?.[""]?.length) {
                  this.toasterService.error(err.error.errors[""][0], "Error", {
                    positionClass: "toast-bottom-right",
                    progressAnimation: "decreasing",
                    progressBar: true,
                  });
                } else if (err.error?.title && err.error.title !== "Bad Request") {
                  this.toasterService.error(
                    "Error de validación  " + err.error["title"],
                    "Error",
                    {
                      positionClass: "toast-bottom-right",
                      progressAnimation: "decreasing",
                      progressBar: true,
                    }
                  );
                } else if (err.error?.[0] && err.error[0].errorCode === "0") {
                  this.toasterService.error(
                    err.error[0].errorDescription,
                    "Error",
                    {
                      positionClass: "toast-bottom-right",
                      progressAnimation: "decreasing",
                      progressBar: true,
                    }
                  );
                } else {
                  throwError("Error");
                }
                break;
              case 403:
                this.showError(
                  err,
                  "No tiene permiso para acceder a esta sección"
                );

                const appError = err.headers.get("application-error");
                if (appError) {
                  return throwError(err);
                }
                break;
              case 404:
                this.toasterService.error(
                  "No se ha podido encontrar el recurso solicitado.",
                  "Error",
                  {
                    positionClass: "toast-bottom-right",
                    progressAnimation: "decreasing",
                    progressBar: true,
                  }
                );
                break;
              case 401:
                /* this.navStateService.clearNavbar();

                this.authService.clearSessionOnExpiry().then(() => {
                  this.authService.setRedirectedFromProtectedRoute(true, this.router.url);
                  this.authService.login();
                }); */

                break;
              case 405:
                this.toasterService.error(
                  "No puede acceder a esta información",
                  "Error",
                  {
                    positionClass: "toast-bottom-right",
                    progressAnimation: "decreasing",
                    progressBar: true,
                  }
                );
                break;
              case 408:
                this.toasterService.error(
                  "Se ha superado el tiempo de espera.",
                  "Error",
                  {
                    positionClass: "toast-bottom-right",
                    progressAnimation: "decreasing",
                    progressBar: true,
                  }
                );
                break;
              case 409:
                this.toasterService.error(
                  "Los datos ya se encuentran registrados.",
                  "Error",
                  {
                    positionClass: "toast-bottom-right",
                    progressAnimation: "decreasing",
                    progressBar: true,
                  }
                );
                break;
              case 420:
                if (err.error["title"] !== undefined) {
                  this.toasterService.error(err.error["title"], "Error", {
                    positionClass: "toast-bottom-right",
                    progressAnimation: "decreasing",
                    progressBar: true,
                  });
                }
                break;
              case 426:
                this.upgradeRequiredProcessError(err);
                break;
              case 500:
                if (err.error.includes("order_cra_un_contact")) {
                  this.toasterService.error(
                    "Contacto de teléfono ya registrado",
                    "Error",
                    {
                      positionClass: "toast-bottom-right",
                      progressAnimation: "decreasing",
                      progressBar: true,
                    }
                  );
                } else {
                  this.toasterService.error(
                    "Se ha producido un error en el servidor",
                    "Error",
                    {
                      positionClass: "toast-bottom-right",
                      progressAnimation: "decreasing",
                      progressBar: true,
                    }
                  );
                }
                break;
              default:
                break;
            }
            //this.toasterService.error(err.error.message, err.error.title, { positionClass: 'toast-bottom-center' });
          } catch (e) {
            this.toasterService.error(
              "Ha ocurrido un error inesperado al procesar la solicitud.",
              "Error",
              {
                positionClass: "toast-bottom-right",
                progressAnimation: "decreasing",
                progressBar: true,
              }
            );
          }
        }
        return throwError(() => err);
      })
    );
  }

  private addHeaderCustomerVersion(req: HttpRequest<any>): HttpRequest<any> {
    let customerVersion = "1"; //sessionStorage.getItem("customer-version");

    if (customerVersion == null) {
      customerVersion = "-";
    }

    req = req.clone({
      setHeaders: {
        CustomerVersion: customerVersion,
        "Cache-Control":
          "no-cache, no-store, must-revalidate, post-check=0, pre-check=0",
        Pragma: "no-cache",
        Expires: "0",
      },
    });

    return req;
  }

  private upgradeRequiredProcessError(err: HttpErrorResponse) {
    if (this.hardReload) {
      return;
    }

    this.hardReload = true;

    if (!this.checkVersionFromLogin) {
      this.showError(
        err,
        "Versión antigua detectada. Actualizando su versión..."
      );
    }

    let releaseVersion = err.headers.get("release-version");

    this.deleteCaches();
    this.swUpdate.activateUpdate().then(() => {
      sessionStorage.setItem("customer-version", releaseVersion);
      document.location.reload();
    });
  }

  private async deleteCaches() {
    try {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    } catch (err) { }
  }

  private showError(err: HttpErrorResponse, message: string) {
    this.toasterService.toastrConfig.preventDuplicates = true;
    this.toasterService.error(message, "Error", {
      positionClass: "toast-bottom-right",
      progressAnimation: "decreasing",
      progressBar: true,
    });
  }
}
